import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { EnvironmentType } from '../environments/environment-type';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  public utilsUrls = {
    apiUrl: environment.apiUrl,
    baseUrl: environment.baseUrl
  };

  // orderId
  photographerId = 122733;
  companyId = 29;
  user = { userId: 122733, userFirstName: 'Saritta', userLastName: 'Di Marco' };
  userType: string = '';

  constructor() {}
}
